document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cc-faq-q');
  if (!btn) return;
  var answer = btn.nextElementSibling;
  if (!answer || !answer.classList.contains('cc-faq-a')) return;
  var isOpen = answer.classList.contains('open');
  answer.classList.toggle('open', !isOpen);
  var arrow = btn.querySelector('.cc-faq-arrow');
  if (arrow) arrow.textContent = isOpen ? '\u25bc' : '\u25b2';
});
